import { store } from "~/store";
import { VITE_OLD_ESHOP } from "@/config/constants.js";
import { AxiosError } from "axios";
import type { ErrorItem } from "@/interfaces/ErrorItem";
import type IJsonApiErrorResponse from "~/interfaces/IJsonApiErrorResponse";

interface Translate {
  name: string;
}

export function getFinalEshopUrl(path: string) {
  return VITE_OLD_ESHOP + path;
}

export function getTranslate(section: string, componentName: string) {
  const translations = store.getters["translations/getSections"];

  if (translations[section]) {
    const translation = translations[section].find(
      (component: Translate) => component.name == componentName,
    );

    if (translation) {
      return translation;
    }
  }
  return null;
}

export function getTitleTranslate(section: string, componentName: string) {
  const translate = getTranslate(section, componentName);
  if (translate) {
    return translate.title;
  }
  return "";
}

export function getTitleTranslateWithOptions(
  section: string,
  componentName: string,
  options: any,
) {
  const translate = getTranslate(section, componentName);
  if (translate) {
    let finalTranslate = translate.title;
    Object.keys(options).forEach((key) => {
      finalTranslate = finalTranslate.replace(`${key}`, `${options[key]}`);
    });
    return finalTranslate;
  }
  return "";
}

export function getLinkSelfTranslate(section: string, componentName: string) {
  const translate = getTranslate(section, componentName);
  let linkSelf = "/";
  if (translate && translate.links && translate.links.self) {
    linkSelf = translate.links.self;
  }
  return linkSelf;
}

export function getEshopLinkTranslate(section: string, componentName: string) {
  const linkSelf = getLinkSelfTranslate(section, componentName);
  return getFinalEshopUrl(linkSelf);
}

export function generateUUID(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function errorsToString(reason: AxiosError): string {
  let text = "";
  if (reason.response && reason.response.data) {
    const data: { errors?: ErrorItem[]; message?: unknown } =
      reason.response.data;
    if (data.errors) {
      const list = data.errors
        .map((error: ErrorItem) => error.detail)
        .join("</li><li>");
      text = `<ul><li>${list}</li></ul>`;
    } else if (data.message && typeof data?.message == "string") {
      text = data.message;
    }
  }
  return text != "" ? text : "Ocurrio un error inesperado";
}

export function loadScript(src: string) {
  return new Promise((resolve, reject) => {
    const exists = document.querySelector(`script[src="${src}"]`);
    if (exists) {
      exists.remove();
    }
    // insert only one time
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve(src);
    script.onerror = () =>
      reject(new Error(`Error al cargar el script: ${src}`));
    document.head.appendChild(script);
    // useHead({
    //   script: [
    //     {
    //       src,
    //       async: true,
    //       type: "text/javascript",
    //       onload: () => resolve(src),
    //       onerror: () => reject(new Error(`Error al cargar el script: ${src}`)),
    //     },
    //   ],
    // });
  });
}

export async function parseError(err: unknown): Promise<string | undefined> {
  if (!err) {
    return undefined;
  }
  console.error(err);
  if ((err as { data: any })?.data) {
    try {
      const json = (err as { data: any }).data as IJsonApiErrorResponse;
      if (json && Array.isArray(json.errors)) {
        return json.errors.map((err) => err.detail).join("\n");
      }
      return json as unknown as string;
    } catch (err2) {
      console.log(err2);
    }
  } else if (err instanceof Error) {
    return err.message;
  } else if (err instanceof Response) {
    try {
      const text = await err.text();
      const json = JSON.parse(text) as IJsonApiErrorResponse;
      if (json && Array.isArray(json.errors)) {
        return json.errors.map((err) => err.detail).join("\n");
      }
      return text;
    } catch (err2) {
      console.log(err2);
      return "Error inesperado - " + err.statusText;
    }
  } else if (typeof err == "string") {
    return err;
  }
  return "Error desconocido - " + err;
}

export function toSlug(text: string) {
  return text
    .toString() // Asegura que sea string
    .normalize("NFD") // Separa los acentos de las letras
    .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
    .toLowerCase() // Convierte a minúsculas
    .trim() // Elimina espacios al inicio/final
    .replace(/[^a-z0-9\s-]/g, "") // Elimina caracteres no deseados
    .replace(/\s+/g, "-") // Reemplaza espacios por guiones
    .replace(/-+/g, "-"); // Reemplaza múltiples guiones por uno
}
